import APIService from 'services/APIService'

const api = APIService()

export const getEvaluation = () => api.get('/ai-tutor-scores/chapter-progress')
